import { render, staticRenderFns } from "./fullDetail.vue?vue&type=template&id=1747d827&scoped=true"
import script from "./fullDetail.vue?vue&type=script&lang=js"
export * from "./fullDetail.vue?vue&type=script&lang=js"
import style0 from "./fullDetail.vue?vue&type=style&index=0&id=1747d827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747d827",
  null
  
)

export default component.exports